import { SHOW_LOADER } from "../../constants/action";

export const showLoader = (data) => ({
  type: SHOW_LOADER,
  payload: data,
});
